import { Injectable } from '@angular/core';
import { Observable, Subject } from 'rxjs';
import { map } from 'rxjs/operators';
import { AuthenticationProcess } from '../../../shared/models/common/authentication-process.model';
import { BaseService } from '../../../shared/services/base.service';
import { GridResponse } from '../../../shared/models/common/grid-response.model';
import { environment } from 'src/environments/environment';
@Injectable({
    providedIn: 'root'
})
export class AuthenticationProcessesService extends BaseService<AuthenticationProcess> {

    private serviceMessage: { severity: string, summary: string, detail?: string } | null = null;

    setServiceMessage(message: { severity: string, summary: string, detail?: string }) {
        this.serviceMessage = message;
    }

    showServiceMessage() {
        if (this.serviceMessage) {
            this.messageService.add(this.serviceMessage);
            this.serviceMessage = null;
            setTimeout(() => {
                this.messageService.clear();
            }, 6000)
        }
    }

    getAllAuthenticationProcesses(): Observable<AuthenticationProcess[]> {
         return this.http.get<GridResponse<AuthenticationProcess>>(`${environment.config.api_url}AuthenticationProcesses`).pipe(map(r => r.rows));
    }

    /**
     * Get enabled authentication processes for login
     * @returns Observable with enabled authentication processes
     */
    getEnabled(): Observable<AuthenticationProcess[]> {
        return this.http.get<AuthenticationProcess[]>(`${environment.config.api_url}AuthenticationProcesses/Enabled`);
    }

    getAuthenticationProcess(id: number): Observable<AuthenticationProcess> {
        return this.http.get<AuthenticationProcess>(`${environment.config.api_url}AuthenticationProcesses/${id}`);
    }

    deleteAuthenticationProcess(authProcess: AuthenticationProcess): Observable<void> {

        const result$ = new Subject<void>();

        this.http.delete<AuthenticationProcess>(`${environment.config.api_url}AuthenticationProcesses/${authProcess.id}`).subscribe({

            next: (data) => {
                this.setServiceMessage({ severity: 'success', summary: this.translateService.instant('authentication_processes.deleted_success') });
                result$.next();
                result$.complete();
            },

            error: (error) => {
                this.setServiceMessage({ severity: 'error', summary: this.translateService.instant('general.error'), detail: error.error.message })
                result$.error(error);
            }

        });

        return result$.asObservable();

    }

    saveAuthenticationProcess(authProcess: AuthenticationProcess): Observable<void> {

        const result$ = new Subject<void>();

        if (authProcess.id) {

            this.http.put<AuthenticationProcess>(`${environment.config.api_url}AuthenticationProcesses/${authProcess.id}`, authProcess).subscribe({

                next: (data) => {
                    this.setServiceMessage({ severity: 'success', summary: this.translateService.instant('authentication_processes.save_success') });
                    result$.next();
                    result$.complete();
                },

                error: (error) => {
                    this.setServiceMessage({ severity: 'error', summary: this.translateService.instant('general.error'), detail: error.error.message })
                    result$.error(error);
                }

            });

        } else {
            this.http.post<AuthenticationProcess>(`${environment.config.api_url}AuthenticationProcesses`, authProcess).subscribe({

                next: (data) => {
                    this.messageService.add({ severity: 'success', summary: this.translateService.instant('authentication_processes.save_success') });
                    result$.next();
                    result$.complete();
                },

                error: (error) => {
                    this.messageService.add({ severity: 'error', summary: this.translateService.instant('general.error'), detail: error.error.message })
                    result$.error(error);
                }

            });
        }

        return result$.asObservable();

    }

}
